import { Checkbox, Modal } from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { IconGps } from "@tabler/icons-react";
import { Fragment, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";

import { usePostApi } from "../../../../../../../hooks";
import { getYachtId, normalizeDate } from "../../../../../../../utils";
import { Button } from "../../../../../../shared/Button/Button";
import { StyledMedicalContent } from "../../MedicalHistory.styled";

enum ELeaveType {
  on = "Onboard",
  leave = "OnLeave",
}

interface Props {
  refetch: () => Promise<void>;
  defaultType: string;
}

const LeaveOnboardModal = ({ refetch, defaultType }: Props) => {
  const { post } = usePostApi();
  const { userid } = useParams();

  const parsedDefault = useMemo(
    () => (defaultType === "OnBoard" ? ELeaveType.on : ELeaveType.leave),
    [defaultType],
  );
  const [open, setOpen] = useState(false);
  const [type, setType] = useState<ELeaveType>(parsedDefault);
  const [date, setDate] = useState<Date | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setType(parsedDefault);
  }, [parsedDefault]);

  const utcDate = normalizeDate(date);

  const clearData = () => {
    setOpen(false);
    setTimeout(() => {
      setDate(null);
      setType(parsedDefault);
    }, 300);
  };

  const handleSubmit = async () => {
    if (!utcDate) return;
    setIsLoading(true);

    await post({
      request: "set-onleave-onboard",
      body: {
        params: {
          userid,
          yachtid: getYachtId(),
          type,
          date: utcDate.toISOString(),
        },
      },
    });
    await refetch();
    clearData();
    setIsLoading(false);
  };
  return (
    <Fragment>
      <Button onClick={() => setOpen(true)}>Set Leave/Onboard</Button>
      <Modal opened={open} onClose={clearData} title="Set Leave/Onboard">
        <div style={{ display: "flex", marginBottom: "20px" }}>
          <StyledMedicalContent
            style={{ alignItems: "center", margin: "0 auto" }}>
            <p>Onboard</p>
            <Checkbox
              icon={IconGps}
              size="lg"
              // disabled={parsedDefault === ELeaveType.on}
              checked={type === ELeaveType.on}
              onChange={() => setType(ELeaveType.on)}
            />
          </StyledMedicalContent>
          <StyledMedicalContent
            style={{ alignItems: "center", margin: "0 auto" }}>
            <p>On Leave</p>
            <Checkbox
              icon={IconGps}
              size="lg"
              // disabled={parsedDefault === ELeaveType.leave}
              checked={type === ELeaveType.leave}
              onChange={() => setType(ELeaveType.leave)}
            />
          </StyledMedicalContent>
        </div>
        <StyledMedicalContent
          style={{
            alignItems: "center",
            margin: "0 auto",
            justifyContent: "center",
          }}>
          <p>Date</p>
          <DatePickerInput
            locale="en"
            w={150}
            valueFormat="DD MMM YYYY"
            dropdownType="modal"
            value={date}
            onChange={d => setDate(normalizeDate(d))}
          />
        </StyledMedicalContent>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "40px",
          }}>
          <Button onClick={clearData} color="red">
            Cancel
          </Button>
          <Button onClick={handleSubmit} loading={isLoading}>
            Save
          </Button>
        </div>
      </Modal>
    </Fragment>
  );
};

export default LeaveOnboardModal;
